import React, { useState, useEffect } from 'react';
import axios from '../../utils/axiosInstance';
import CommonForm from '../../components/commonComponent/CommonForm';
import { validateForm } from '../../utils/formUtils';
import { toastSuccess, toastError } from '../../utils/alertHelper';
import { useNavigate, useParams } from "react-router-dom";
import qs from 'qs';
import MapPickerModal from '../../components/commonComponent/MapPickerModal'; 

const Guestcreate = () => {
  const { id } = useParams();  // Get user id from URL param if any
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    firstName: '',
    middleName: '',
    mobileNumber: '',
    city: '6884664796aa0f4f2f79ec1c',
    business_name: '',
    email: '',
    password: '',
  });

   const [dropdowns, setDropdowns] = useState({
    cities: []
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const cityRes = await axios.get('/admin/api/city');
        const cities = cityRes.data?.cities || [];
        
        setDropdowns({
          cities: cities.map(c => ({ value: c._id, label: c.name })),
        });
      } catch (error) {
        toastError('Failed to load dropdown data');
      }
    };

    fetchDropdownData();
  }, []);

  // If editing, fetch user data and populate formValues
  useEffect(() => {
    if (!id) return;

    const fetchUser = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`/api/user/${id}`);
        const user = res.data.user;

        if (!user) throw new Error('User not found');

        // Map API user data to formValues shape
        setFormValues({
          firstName: user.firstName || '',
          middleName: user.middleName || '',
          mobileNumber: user.mobileNumber || '',
          city: user.city ? user.city._id : '6884664796aa0f4f2f79ec1c',
          business_name: user.business && user.business.length > 0 ? user.business[0].businessName || '' : '',
          email: user.email || '',
          password: '',
        });

      } catch (error) {
        console.error('Failed to fetch user:', error);
        toastError('Failed to fetch user data');
        navigate('/guest');
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [id, navigate]);
 const handleSubmit = async () => {
  const validationRules = {
    firstName: { required: true },
    middleName: { required: true },
    mobileNumber: { required: true, mobile: true },
    city: { required: true },
    business_name: { required: true },
    email: { required: true },
    ...(id ? {} : { password: { required: true } }),
  };

  const validationErrors = validateForm(formValues, validationRules);
  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    return;
  }

  try {
    const businessData = formValues.business_name ? [{
      businessName: formValues.business_name,
      primaryBusiness: true,
    }] : [];

    const formData = new FormData();

    // Business
    formData.append('business', JSON.stringify(businessData));

    // Other form fields
    formData.append('firstName', formValues.firstName || '');
    formData.append('middleName', formValues.middleName || '');
    formData.append('mobileNumber', formValues.mobileNumber || '');
    formData.append('city', formValues.city || '');
    formData.append('email', formValues.email || '');
    formData.append('password', formValues.password || '');
    formData.append('userType', 'Guest');

    const config = {
      headers: { 'Content-Type': 'multipart/form-data' },
    };

    if (id) {
      await axios.put(`/api/user/${id}`, formData, config);
      toastSuccess('Guest updated successfully!');
    } else {
      await axios.post('/api/user/create', formData, config);
      toastSuccess('Guest created successfully!');
    }

    navigate('/guest');
  } catch (error) {
    toastError('Failed to save Guest');
    console.error(error);
  }
};

  const handleCancel = () => {
    // Reset form and errors
    setFormValues({
      firstName: '',
      middleName: '',
      mobileNumber: '',
      city: '6884664796aa0f4f2f79ec1c',
      business_name: '',
      email: '',
      password: '',
    });
    setErrors({});
  };

  const fieldSets = [
    {
      section: 'Guest Registration',
      fields: [
        { name: 'firstName', label: 'First Name', placeholder: 'First Name', type: 'text', required: true },
        { name: 'middleName', label: 'Middle Name', placeholder: 'Middle Name', type: 'text', required: true },
        { name: 'mobileNumber', label: 'Mobile Number', placeholder: 'Mobile Number', type: 'phoneWithCountry', required: true },
        {
          name: 'city',
          label: 'City',
          placeholder: 'Select City',
          type: 'select',
          options: dropdowns.cities,
          required: true
        },
        { name: 'business_name', label: 'Company Name', placeholder: 'Company Name', type: 'text', required: true },
        { name: 'email', label: 'Email ID', placeholder: 'Email ID', type: 'email', required: true },
        { name: 'password', label: 'Password', placeholder: 'Password', type: 'password', required: true },
      ],
    },
  ];

  if (loading) return <div>Loading user data...</div>;

  return (
    <div className="container mt-4">
      <h4 className="mb-3 text-dark border-bottom pb-2">{id ? 'Edit Guest' : 'Guest Registration'}</h4>

      <CommonForm
        title="Guest Registration"
        fields={fieldSets}
        values={formValues}
        onChange={(updated) => setFormValues((prev) => ({ ...prev, ...updated }))}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        errors={errors}
        requiredFields={['firstName', 'middleName', 'mobileNumber', 'city', 'business_name', 'email', ...(id ? [] : ['password'])]}
        submitLabel={id ? 'Update' : 'Save'}
        cancelLabel="Reset"
      />
    </div>
  );
};

export default Guestcreate;
